import React, { useEffect, useState } from 'react';
import {
  Home,
  Building2,
  CalendarCheck,
  MapPin,
  Truck,
  Building,
  User,
  LogOut,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  WrenchIcon,
  Calendar1,
  SlidersHorizontal,
  LayoutPanelTop,
  UserCircle,
  Wrench,
  Ruler,
  Factory,
  Car,
  LandPlot,
  Fuel,
  BriefcaseBusiness,
  Snowflake,
  MapPinned,
  FlaskConical,
  Flame,
  Zap,
  ChartLine,
  ChartPie,
  FileChartLine,
  FileChartPie,
  FuelIcon
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import {
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedYear, loginSuccess } from '../redux/slices/authSlice';
import api from '../axios/api';
import PATHS from '../routes/routes';
import { showNotification } from '../redux/slices/notificationSlice';
import CustomButton from '../componentsII/Buttons';

import Looks3OutlinedIcon from '@mui/icons-material/Looks3Outlined';
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';
import LooksTwoOutlinedIcon from '@mui/icons-material/LooksTwoOutlined';

import { fetchCounts } from '../redux/slices/countsSlice';
import { selectCounts } from '../redux/slices/countsSlice';

import { useRef } from 'react';
import dayjs from 'dayjs';

const MenuItem2 = ({ icon: Icon, label, path, onClick, badge, children, sidebarOpen }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = children && children.length > 0;
  const location = useLocation();

  const isActive = path === location.pathname ||
    (children?.some(child => child.path === location.pathname));

  return (
    <div>
      <div>
        <button
          onClick={() => {
            if (hasChildren) {
              setIsOpen(!isOpen);
            } else {
              onClick?.();
            }
          }}
          className={`w-full flex items-center px-3 py-2 rounded-lg text-sm gap-2 
          ${isActive ? 'bg-green-50 text-green-700 border-green-500 border-2' : 'text-gray-700 hover:bg-green-50 hover:text-green-700'}
          transition-colors duration-150`}
          title={label}
        >
          {/* Icon and text grouped closely */}
          <div className="flex items-center space-x-2">
            {Icon && <Icon size={20} className={isActive ? 'text-green-600' : 'text-gray-500'} />}
            {sidebarOpen && <span className={`flex-1 font-medium text-left`}>{label}</span>}
          </div>

          {/* Badge and chevrons aligned to the right */}
          <div className="ml-auto flex items-center gap-2">
            {/* {badge && sidebarOpen && (
              <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-600">{badge}</span>
            )} */}
            {badge !== undefined && badge !== null && sidebarOpen && (
              <span className="px-2 py-0.5 text-xs rounded-full bg-green-100 text-green-600">{badge}</span>
            )}
            {hasChildren && sidebarOpen && (
              isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />
            )}
          </div>
        </button>

        {/* Render children (subitems) */}
        {hasChildren && isOpen && sidebarOpen && (
          <div className="space-y-1 pl-6">
            {children}
          </div>
        )}
      </div>

    </div>

  );
};


const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [years, setYears] = useState([]);
  const Counts = useSelector((state) => selectCounts(state));

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedYearTemp, setSelectedYearTemp] = useState(null);

  //States to Manage the open close of the year selection
  const [showSelect, setShowSelect] = useState(false);
  const dropdownRef = useRef(null);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const userRole = useSelector((state) => state.user.user?.roleCode);
  const selectedYear = useSelector((state) => state.user.selectedYear);

  const showCounts = selectedYear?.start_year_month != null && selectedYear?.end_year_month != null;


  useEffect(() => {
    if (user?.company?.id && selectedYear?.id) {
      dispatch(fetchCounts({
        companyId: user.company.id,
        yearId: selectedYear.id
      }));
    }
  }, [user?.company?.id, selectedYear?.id]);


  const getNavigationItems = () => {
    if (userRole === 'ADMIN') {
      return [
        {
          label: 'Masters',
          icon: SlidersHorizontal,
          children: [
            { label: 'Scope3 Template', icon: LayoutPanelTop, path: PATHS.MASTERS_SCOPE3_TEMPLATE },
            { label: 'User', icon: UserCircle, path: PATHS.MASTERS_USERS },
            { label: 'Equipment Types', icon: Wrench, path: PATHS.MASTERS_EQUIPMENT_TYPES },
            { label: 'General', icon: Ruler, path: PATHS.MASTERS_GENERAL },
            { label: 'Sector', icon: Factory, path: PATHS.MASTERS_SECTOR },
            { label: 'Industry', icon: Building, path: PATHS.MASTERS_INDUSTRY },
            { label: 'SubIndustry', icon: Building2, path: PATHS.MASTERS_SUBINDUSTRY },
            { label: 'Vehicle Type', icon: Car, path: PATHS.MASTERS_VEHICLE_TYPE },
            { label: 'Vehicle Sub Type', icon: Car, path: PATHS.MASTERS_VEHICLE_SUB_TYPE },
            { label: 'Vehicle Make', icon: Car, path: PATHS.MASTERS_VEHICLE_MAKE },
            { label: 'Vehicle Model', icon: Car, path: PATHS.MASTERS_VEHICLE_MODEL },
            { label: 'Country', icon: MapPinned, path: PATHS.MASTERS_COUNTRY },
            { label: 'State', icon: LandPlot, path: PATHS.MASTERS_STATES },
            { label: 'Industrial Gas', icon: FlaskConical, path: PATHS.MASTERS_INDUSTRIAL_GAS },
            { label: 'Natural Gas', icon: FlaskConical, path: PATHS.MASTERS_NATURAL_GAS },
            { label: 'Refrigerant Types', icon: Snowflake, path: PATHS.MASTERS_REFRIGERANT_TYPES },
            { label: 'Fuel Types', icon: Fuel, path: PATHS.MASTERS_FUEL_TYPES },
            { label: 'Primary Usage', icon: BriefcaseBusiness, path: PATHS.MASTERS_PRIMARY_USAGE },
            { label: 'Primary Usage Type', icon: BriefcaseBusiness, path: PATHS.MASTERS_PRIMARY_USAGE_TYPE },


          ]
        },
        {
          label: 'Scope 1 Emission Factors',
          icon: LooksOneOutlinedIcon,
          children: [
            { label: 'Fuel Type Emission', icon: FuelIcon, path: PATHS.MASTERS_FUEL_EMISSION },
            { label: 'Refrigerant Emission', icon: Snowflake, path: PATHS.MASTERS_REFRIGERANT_EMISSION },
            { label: 'Industrial Gas Emisssion', icon: Factory, path: PATHS.MASTERS_INDUSTRIAL_GAS_EMISSION },
            { label: 'Natural Gas Emisssion', icon: Factory, path: PATHS.MASTERS_NATURAL_GAS_EMISSION },
            { label: 'Vehicle Distance Wise Emission', icon: Car, path: PATHS.MASTERS_VEHICLE_DISTANCE_WISE_EMISSION },
            { label: 'Vehicle Fuel Wise Emission', icon: Car, path: PATHS.MASTERS_VEHICLE_FUEL_WISE_EMISSION },]
        },
        {
          label: 'Scope 2 Emission Factors',
          icon: LooksTwoOutlinedIcon,
          children: [
            { label: 'Electricity Emission', icon: Zap, path: PATHS.MASTERS_ELECTRICITY_EMISSION },
            { label: 'Heat & Steam Usage', icon: Flame, path: PATHS.MASTERS_HEAT_STEAM_EMISSION },
            { label: 'Purchased Cooling', icon: Snowflake, path: PATHS.MASTERS_PURCHASED_COOLING_EMISSION },
          ]
        },
        { label: 'Scope3 Data Submission', icon: Looks3OutlinedIcon, path: PATHS.SCOPE3_DATA_SUBMISSION },
        { label: 'Cron Logs', icon: BriefcaseBusiness, path: PATHS.CRON_LOGS }
      ];
    } else if (userRole === 'USER') {
      return [
        { label: 'Climate Profile', icon: Home, path: '/account/climate-profile' },
        {
          label: 'Company',
          icon: Building2,
          children: [
            { label: 'Company Details', icon: Building, path: '/account/company-details' },
            { label: 'Data Reporting year', icon: CalendarCheck, path: '/account/data-reporting-year' },
            { label: 'Locations', icon: MapPin, path: '/account/locations',  badge: showCounts ? Counts?.locations : undefined },
            { label: 'Vehicles', icon: Truck, path: '/account/vehicles',  badge: showCounts ? Counts?.vehicles : undefined, },
            { label: 'Equipment', icon: WrenchIcon, path: '/account/equipment',  badge: showCounts ? Counts?.equipments : undefined, },
          ]
        },
        {
          label: 'Scope 1',
          icon: LooksOneOutlinedIcon,
          children: [
            { label: 'Natural Gas Consumption (Location)', icon: FlaskConical, path: PATHS.SCOPE_1_NATURAL_GAS_CONSUMPTION_LOCATION },
            { label: 'Vehicle Usage (Fuel)', icon: Car, path: PATHS.SCOPE_1_VEHICLE_USAGE_FUEL },
            { label: 'Vehicle Usage (Distance)', icon: Car, path: PATHS.SCOPE_1_VEHICLE_USAGE_DISTANCE },
            { label: 'Fuel consumption (Equipment)', icon: Fuel, path: PATHS.SCOPE_1_FUEL_CONSUMPTION_EQUIPMENT },
            { label: 'Refrigerant Consumption', icon: Snowflake, path: PATHS.SCOPE_1_REFRIGERANT_CONSUMPTION },
            { label: 'Industrial Gas Consumption', icon: FlaskConical, path: PATHS.SCOPE_1_INDUSTRIAL_GAS_CONSUMPTION },
          ]
        },
        {
          label: 'Scope 2',
          icon: LooksTwoOutlinedIcon,
          children: [
            { label: 'Electricity Usage', icon: Zap, path: PATHS.SCOPE_2_ELECTRICITY_USAGE },
            { label: 'Heat & Steam Usage', icon: Flame, path: PATHS.SCOPE_2_HEAT_STREAM_USAGE },
            { label: 'Purchased Cooling', icon: Snowflake, path: PATHS.SCOPE_2_PURCHASED_COOLING },
          ]
        },
        { label: 'Scope 3', icon: Looks3OutlinedIcon, path: PATHS.SCOPE_3 },
        {
          label: 'Analytics & Reduction Targets',
          icon: ChartPie,
          children: [
            { label: 'Footprint Analytics', icon: FileChartPie, path: PATHS.ANALYTICS_REDUCTION_FOOTPRINT_ANALYTICS },
            { label: 'Reduction Target Modeling', icon: FileChartPie, path: PATHS.ANALYTICS_REDUCTION_REDUCTION_TARGET_MODEL },
          ]
        },
        {
          label: 'GHG Metric Reports',
          icon: ChartLine,
          children: [
            { label: 'GHG Methodology Report', icon: FileChartLine, path: PATHS.METRIC_REPORT_GHG_METHODOLOGY },
            { label: 'ISSB GHG Metric Report', icon: FileChartLine, path: PATHS.METRIC_REPORT_IISB_GHG_METRIC },
            { label: 'UNFCCC Report', icon: FileChartLine, path: PATHS.METRIC_REPORT_UNFCCC_REPORT },
            { label: 'BRSR Report', icon: FileChartLine, path: PATHS.METRIC_REPORT_BRSR_REPORT },
          ]
        },
      ];
    }
  };

  const navigation = getNavigationItems();

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("reduxState");
    navigate('/login');
  };

  const handleGoBackToAdmin = async () => {
    try {
      const response = await api.post(`/auth/resignasadmin`, { id: user.adminContext.adminId, adminToken: user.adminContext.oldToken });
      if (response.data.status == 200) {
        const userDetails = response.data?.userDetails;
        const token = response.data?.accessToken;
        localStorage.setItem("user", JSON.stringify(userDetails));
        dispatch(setSelectedYear(userDetails.selectedYear));
        localStorage.setItem("token", token);
        dispatch(loginSuccess({ user: userDetails, token: token }));
        dispatch(
          showNotification({
            message: 'Login Successful! Redirecting to your dashboard...',
            type: "success",
          })
        );
        navigate('/masters/users');
      } else {
        dispatch(showNotification({
          message: response.data.message,
          type: 'error',
        }));
      }
    } catch (error) {
      console.error('Error Logging In', error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`/company/companyDataYear?company_id=${user.company.id}`);
        setYears(response.data.data);
      } catch (error) {
        console.error('Error fetching years:', error);
      }
    };
    fetchData();
  }, []);

  const handleYearSelect = (year) => {
    setSelectedYearTemp(year);
    setShowSelect(false);
    setConfirmDialogOpen(true);
  };

  const handleConfirmYearChange = async () => {
    try {
      if (!selectedYearTemp) {
        showNotification({
          message: 'No year selected to update.',
          type: 'error',
        });
        return;
      }

      const response = await api.put('/company/updateSelectedCompanyDataYear', {
        year_id: selectedYearTemp.id,
        company_id: user.company.id,
      });

      if (response.status === 200) {
        dispatch(setSelectedYear(selectedYearTemp));
        showNotification({
          message: 'Year selection updated successfully!',
          type: 'success',
        });
        window.location.reload();
      } else {
        showNotification({
          message: 'Failed to update the year selection. Please try again.',
          type: 'error',
        });
      }
      setSelectedYearTemp(null);
      setConfirmDialogOpen(false);
    } catch (error) {
      showNotification({
        message: error.response?.data?.message || 'An error occurred while updating the year.',
        type: 'error',
      });
      console.error('Error updating year selection:', error);
    }
  };

  const handleCancelYearChange = () => {
    setSelectedYearTemp(null);
    setConfirmDialogOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowSelect(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">

      {/* Mobile menu overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-gray-800/50 z-40 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Navbar */}
      <nav className="fixed top-0 z-30 w-full bg-white border-b shadow-sm">
        <div className="px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setMobileMenuOpen(true)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
            >
              <Menu size={20} />
            </button>
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="hidden lg:block p-2 rounded-lg hover:bg-gray-100"
            >
              <Menu size={20} />
            </button>
            <span className="text-xl font-semibold text-green-600">Nirvritti Dashboard</span>

          </div>

          {/* Year and User */}
          <div className="flex items-center gap-4">
            {user.roleCode === "ADMIN" || selectedYear == null || selectedYear.start_year_month == null || selectedYear.end_year_month == null || selectedYear.id == null ? "" : <>
                <div className="relative inline-flex items-center gap-2" ref={dropdownRef}>
                  {/* Reporting Year div */}
                  <div
                    className="bg-green-100 p-2 rounded-md cursor-pointer hover:border hover:border-green-400"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowSelect((prev) => {
                        return !prev;
                      });
                    }}
                  >
                    Reporting Year {dayjs().month(selectedYear?.start_year_month || "").format('MMM')} {selectedYear?.start_year} - {dayjs().month(selectedYear?.end_year_month || "").format('MMM')} {selectedYear?.end_year}
                  </div>

                  {/* Calendar Icon */}
                  <div className="relative inline-block">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowSelect((prev) => {
                          return !prev;
                        });
                      }}
                      className="p-2 rounded-full hover:bg-green-100 focus:outline-none"
                      aria-label="Toggle Year Selector"
                      title="select reporting year"
                    >
                      <Calendar1 className="text-gray-600" size={20} />
                    </button>

                    {/* Dropdown */}
                    {showSelect && (
                      <div
                        className="absolute mt-2 bg-white transform -translate-x-1/2 w-max shadow-lg rounded-md"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {years.map((y) => (
                          <MenuItem
                            key={y.id}
                            value={y.start_year}
                            onClick={() => handleYearSelect(y)}
                            sx={{
                              backgroundColor: selectedYear?.id === y.id ? "#16A34A" : "white",
                              color: selectedYear?.id === y.id ? "white" : "black",
                              border: "1px solid #e0e0e0",
                              "&:hover": {
                                backgroundColor: "#16A34A",
                                color: "white",
                              },
                              width: "180px",
                              overflow: "hidden",
                              padding: "10px",
                            }}
                          >
                            {dayjs().month(y.start_year_month).format("MMM")} {y.start_year} - {dayjs().month(y.end_year_month).format("MMM")} {y.end_year}
                          </MenuItem>
                        ))}
                        <MenuItem
                          sx={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid #e0e0e0",
                            "&:hover": {
                              backgroundColor: "#16A34A",
                              color: "white",
                            },
                            width: "180px",
                            overflow: "hidden",
                            padding: "10px",
                          }}
                          onClick={() => {
                            navigate("/account/data-reporting-year");
                            setShowSelect(false);
                          }}
                        >
                          + Add New Reporting Year
                        </MenuItem>
                      </div>
                    )}
                  </div>
                </div>

              </>}
            <button title={`${user?.firstName}-profile`} className="flex items-center gap-2 text-sm text-gray-700 p-2 rounded-full hover:bg-green-100" onClick={() => navigate('/account/myprofile')}>
              <User size={20} />
            </button>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <aside className={`
        fixed top-0 left-0 z-50 h-full bg-white border-r shadow-lg transition-transform duration-300
        lg:translate-x-0 lg:z-20 lg:top-16
        ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        ${sidebarOpen ? 'w-[350px]' : 'w-20'}
      `}>
        {/* Mobile header */}
        <div className="flex items-center justify-between p-4 lg:hidden border-b">
          <span className="text-xl font-semibold text-green-600">Dashboard</span>
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="p-2 rounded-lg hover:bg-gray-100"
          >
            <X size={20} />
          </button>
        </div>

        {/* Sidebar content */}
        <div className="flex flex-col h-[calc(100%-4rem)] lg:h-[calc(100vh-4rem)] overflow-y-auto">
          {/* Navigation Menu */}
          <div className="p-4 space-y-2">
            {navigation.map((item, index) => (
              <div key={index}>
                {/* Parent Menu Item */}
                <MenuItem2
                  icon={item.icon}
                  label={item.label}
                  path={item.path}
                  sidebarOpen={sidebarOpen}
                  onClick={() => {
                    navigate(item.path)
                  }}
                  badge={item.badge}
                >
                  {/* Render Children (Submenus) */}
                  {item.children?.map((child, childIndex) => {
                    return (
                      <MenuItem2
                        key={childIndex}
                        icon={child.icon}
                        label={child.label}
                        path={child.path}
                        sidebarOpen={sidebarOpen}
                        onClick={() => {
                          navigate(child?.path);
                        }}
                        badge={child.badge}
                      />
                    )
                  })}
                </MenuItem2>
                <div className="border-t border-gray-400 my-2"></div>
              </div>
            ))}
          </div>


          {/* Logout Button */}
          <div className="mt-auto border-t">
            <MenuItem2
              key={5}
              icon={LogOut}
              label={user.adminContext?.isAdminImpersonating ? 'Go Back to Admin' : 'Logout'}
              onClick={user.adminContext?.isAdminImpersonating ? handleGoBackToAdmin : handleLogout}
              sidebarOpen={sidebarOpen}
              path={user.adminContext?.isAdminImpersonating ? '/admin-dashboard' : '/logout'}
            />

          </div>
        </div>

      </aside>

      {/* Main content */}
      <main className={`
        pt-16 min-h-screen transition-all duration-300
        ${sidebarOpen ? 'lg:pl-[350px]' : 'lg:pl-20'}
      `}>
        <div className="p-6">
          {children}
        </div>
      </main>

      <Dialog
        open={confirmDialogOpen}
        onClose={handleCancelYearChange}
        aria-labelledby="year-change-dialog-title"
      >
        <DialogTitle id="year-change-dialog-title">
          Confirm Year Change
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the year to{' '}
            {dayjs(`${selectedYearTemp?.start_year_month}-01`, 'M-DD').add(1, 'month').format('MMM')}{' '}
            {selectedYearTemp?.start_year} -{' '}
            {dayjs(`${selectedYearTemp?.end_year_month}-01`, 'M-DD').add(1, 'month').format('MMM')}{' '}
            {selectedYearTemp?.end_year}?
            This action will change your currently selected year.
          </DialogContentText>

        </DialogContent>
        <DialogActions>
          <div className="w-full flex justify-end gap-5 items-center">
            <CustomButton
              className="bg-red-500 hover:bg-red-700 text-white "
              click={() => handleCancelYearChange()}
              text="Cancel"
            />
            <CustomButton
              className="bg-green-600 hover:bg-green-700 text-white "
              text="Confirm"
              click={handleConfirmYearChange}
            />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Layout;